import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from 'syf-component-library/ui/patterns/Grid/Grid';
import Inline from 'syf-component-library/ui/spacing/Inline/Inline';
import Inset from 'syf-component-library/ui/spacing/Inset/Inset';
import { Small } from 'syf-component-library/ui/typography';
import Body from 'syf-component-library/ui/typography/Body';
export const TermsAndConditions = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const Disclaimer = ({ headingText, paragraph, iconFAText, dataCy }) => {
    return (_jsxs(Grid, Object.assign({ container: true }, { children: [_jsx(Grid, Object.assign({ item: true }, { children: _jsxs(TermsAndConditions, { children: [_jsx(FontAwesomeIcon, { icon: iconFAText, size: "lg" }), _jsx(Inline, { size: "medium" }), _jsx(Body, Object.assign({ "data-cy": `${dataCy}-title`, isInline: false, weight: "bold" }, { children: headingText }))] }) })), _jsx(Grid, Object.assign({ item: true }, { children: _jsx(Inset, Object.assign({ "data-cy": `${dataCy}-paragraph`, "data-testid": "disclaimer-paragraph", top: "small" }, { children: paragraph && _jsx(Small, Object.assign({ isInline: false }, { children: paragraph })) })) }))] })));
};
export default Disclaimer;
